import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import ServiceRequestForm from './ServiceRequestForm';
import { useContactModal } from '../context/ContactModalContext';
import './ServiceRequestModal.css';

// Popup that hosts the shared service-request form, opened from "Get In Touch".
const ServiceRequestModal = () => {
  const { open, closeModal } = useContactModal();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') closeModal(); };
    document.addEventListener('keydown', onKey);
    document.body.classList.add('srm-lock');
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.classList.remove('srm-lock');
    };
  }, [open, closeModal]);

  if (!open) return null;

  // Portal to <body> so the fixed overlay escapes the SmoothScroll transform
  // (a transformed ancestor otherwise becomes the containing block for fixed).
  return createPortal(
    <div className="srm-overlay" onClick={closeModal} role="dialog" aria-modal="true" aria-label="Service request">
      <div className="srm-dialog contact-form-card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="srm-close" onClick={closeModal} aria-label="Close">
          <FaTimes />
        </button>
        <ServiceRequestForm source="Service Request (Popup)" />
      </div>
    </div>,
    document.body
  );
};

export default ServiceRequestModal;
